import { LANGUAGE_CODES, PROTOCOL_STATUS, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

// Validador interno para cada ejercicio dentro de la plantilla
const protocolExerciseItemSchema = z.object({
  exerciseId: z.string(VALIDATION_KEYS.PROTOCOL.INVALID_EXERCISE),
  series: z
    .number()
    .int()
    .min(1, VALIDATION_KEYS.PROTOCOL.SERIES_MIN_LENGTH)
    .default(3),
  repetitions: z.string().min(1, VALIDATION_KEYS.PROTOCOL.REPS_REQUIRED), // Ej: "12" o "30 seg"
  restSeconds: z
    .number()
    .int()
    .nonnegative(VALIDATION_KEYS.GENERIC.NUMBER_POSITIVE)
    .default(60),
  frequency: z.string().min(1, VALIDATION_KEYS.PROTOCOL.FREQUENCY_REQUIRED), // Ej: "1 vez al dí­a"
  notes: z.string().optional().nullable(),
  order: z.number().int().default(0),
  
});

// El cimiento común del contenedor
const baseProtocolSchema = z.object({
  clinicId: z.string().uuid().optional().nullable(),
  description: z.string().optional().nullable(),
  status: z.enum(PROTOCOL_STATUS).default("ACTIVE"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),
});

// Esquema de Creación: Valida el nombre y el conjunto de ejercicios
export const createProtocolSchema = baseProtocolSchema.extend({
  name: z.string().min(1, VALIDATION_KEYS.PROTOCOL.NAME_REQUIRED),
  exercises: z
    .array(protocolExerciseItemSchema)
    .min(1, VALIDATION_KEYS.PROTOCOL.EXERCISES_MIN_LENGTH),
});

// Esquema de Actualización: Todo pasa a ser opcional dinámicamente
export const updateProtocolSchema = createProtocolSchema.partial();

export const createProtocolTranslationSchema = createProtocolSchema.partial();